//! api
// export const api =
//     'http://192.168.2.111/OfficeProject/mmspin.com/public/api';
// export const imageApi =
//     'http://192.168.2.111/OfficeProject/mmspin.com/public';
export const api = 'https://mmspin.com/api';
export const imageApi = 'https://mmspin.com';
// export const api = "http://127.0.0.1:8000/api";
// export const imageApi = "http://127.0.0.1:8000";

//useFetch
async function useFetch({url, method, data = null, token}) {
    const generalData = (token, method) => {
        return {
            method: `${method}`,
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            },
        };
    };
    const test = generalData(token, method);
    if (data) {
        const post = JSON.stringify(data);
        test['body'] = post;
    }
    console.log(data);
    const response = await fetch(`${api}/admin/${url}`, test);
    const result = await response.json();
    console.log(result);
    return result;
}
export default useFetch;

export const usePostForm = async ({url, method, data, token, checkStatus = false}) => {
    const generalData = (token, method) => {
        return {
            method: `${method}`,
            headers: {
                Accept: 'application/json',
                Authorization: 'Bearer ' + token,
            },
        };
    };
    const test = generalData(token, method);
    if (data) {
        test['body'] = data;
    }
    console.log(test);
    const response = await fetch(`${api}/admin/${url}`, test);
    const result = await response.json();
    if (checkStatus && (!response.ok || result.success === false)) throw result;
    return result;
};

// image fetching url

export async function getGiftProducts({ token, signal }) {
    const response = await fetch(`${api}/admin/bahozay/gift-products`, {
        headers: { Accept: "application/json", Authorization: `Bearer ${token}` },
        signal,
    });
    const result = await response.json();
    if (!response.ok || result.success !== true || !Array.isArray(result.data)) {
        throw new Error(result.message || "Unable to load gift products.");
    }
    return result.data;
}
